//@flow
import styled from "styled-components"

const DropTarget = styled.div`
  border: 1px solid ${({ theme }) => theme.secondary};
  padding: 1rem;
  display: flex;
  align-items: center;
  min-height: 125px;
  min-width: 125px;
`

export default DropTarget



// WEBPACK FOOTER //
// ./src/UI/FileUploader/DropTarget.js